


// Generated from io.spcfy.spin.export.SpinExportFile

export type SpinExportFileKey =
  "SPINS_CSV" |
  "SPINS_FASTA" |
  "MEMBERS_CSV" |
  "MEMBERS_FASTA" |
  "TAXONOMY_CSV";


export interface SpinExportFileDTO {
  key: SpinExportFileKey;
  fileName: string;
  label: string;
  costHint: string;    
}


export const SpinExportFiles: Record<SpinExportFileKey, SpinExportFileDTO> = {
  SPINS_CSV: { key: "SPINS_CSV", fileName: "spins.csv", label: "One row per SPIN (incl. unity & reach)", costHint: "~65s, 210 MB" },
  SPINS_FASTA: { key: "SPINS_FASTA", fileName: "spins.fasta", label: "Representative sequence per SPIN (FASTA)", costHint: "~16s, 177 MB" },
  MEMBERS_CSV: { key: "MEMBERS_CSV", fileName: "spin_members.csv", label: "One row per member OTU (incl. its sequence)", costHint: "~39s, 533 MB" },
  MEMBERS_FASTA: { key: "MEMBERS_FASTA", fileName: "spin_members.fasta", label: "All member sequences (FASTA, swarm-ready)", costHint: "~38s, 464 MB" },
  TAXONOMY_CSV: { key: "TAXONOMY_CSV", fileName: "spin_taxonomy.csv", label: "Resolved taxonomy & blast evidence per source", costHint: "~23s, 458 MB" }
};
